/** * * Asynchronously loads the component for
NetworkPolicy
* */ import { lazyLoad } from "utils/loadable";
export const NetworkPolicy = lazyLoad(
  () => import("./index"),
  (module) => module.NetworkPolicy
);
